<template>
  <div class="bodyback-light pages">
    <notifications></notifications>
    <navmenu></navmenu>

    <div class="container pb-0 pt-md-5 pt-sm-5 pt-5">
      <div class="row justify-content-center">
        <div class="col-xl-4 col-lg-7 forms card-alerts">
          <form action="">
            <div class="text-center custom-col">
              <h1 class="title-view-2 mb-1">Hello</h1>
              <div class="textInHorizontalLine">
                <span>{{ supplierName }}</span>
              </div>
            </div>

            <div class="card pb-3 mt-4 mb-2">
              <div class="col-12 text-center">
                <i
                  class="f-30"
                  v-bind:class="[
                    { 'text-success flaticon-check-3': isConfirmed },
                    { 'text-warning flaticon-traffic-signal': isCancelled },
                    { 'text-warning flaticon-traffic-signal': isFinished },
                    { 'text-warning flaticon-traffic-signal': isStarted },
                    { 'text-danger flaticon-circle': isUnconfirmed },
                    { 'text-danger flaticon-traffic-signal': isReassigned },
                    { 'text-danger flaticon-error': isAnError }
                  ]"
                ></i>

                <p class="p-content-card text-center">
                  The Reservation
                  <span class="strong-lg d-block "> {{ bookingNumber }}</span>

                  <span v-if="isConfirmed"
                    >has been <strong>Confirmed.</strong>
                  </span>
                  <span v-if="isCancelled">
                    has been <strong> Cancelled.</strong>
                  </span>
                  <span v-if="isFinished">
                    has been <strong> Finished.</strong>
                  </span>
                  <span v-if="isStarted">
                    has been <strong> Started.</strong>
                  </span>
                  <span v-if="isUnconfirmed">couldn't be confirmed. </span>
                  <span v-if="isReassigned"
                    >has been reassigned to another partner.
                  </span>
                  <span v-if="isAnError"
                    >couldn't be confirmed. An error occurred while confirming
                    this reservation. Please try again.</span
                  >
                </p>

                <hr />
                <span class="info-card text-center">
                  For assistance please contact us
                  <a href="mailto:info@rhomtrip.com">info@rhomtrip.com</a>
                </span>
              </div>

              <div class="loading mt-3" v-if="load">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <layoutFooter class="footer-pages"></layoutFooter>
  </div>
</template>
<script>
import Navbarpages from "@/views/Layout/Navbarpages";
import endpoint from "../../Commons/Services";
import swal from "sweetalert2";
import layoutFooter from "../../Layout/ContentFooter.vue";
export default {
  data() {
    return {
      load: false,
      isCancelled: false,
      isAnError: false,
      isConfirmed: false,
      isUnconfirmed: false,
      isFinished: false,
      isStarted: false,
      isReassigned: false,
      bookingNumber: "",
      supplierName: "",
      operatorId: "",
      action: ""
    };
  },
  async created() {
    let reservationId = this.$route.params.id;
    this.action = this.$route.query.action;
    this.operatorId = this.$route.query.operator
      ? this.$route.query.operator
      : null;
    this.supplierName = this.$route.query.supplierName
      ? this.$route.query.supplierName
      : "";
    await this.confirmedReservationById(
      reservationId,
      this.action,
      this.operatorId
    );
  },
  methods: {
    async confirmedReservationById(reservationId, action, operatorId) {
      try {
        this.load = true;
        let {
          data
        } = await endpoint.reservations.services.updateReservationStatusToComfirm(
          reservationId,
          action,
          operatorId
        );
        this.load = false;
        if (data.status) {
          let { reservation, action } = data.data;
          if (reservation) {
            this.bookingNumber = reservation.booking_number;
            this.supplierName = this.supplierName
              ? this.supplierName
              : reservation.supplier.businessDetails.name;
            if (action === "cancel") {
              this.isCancelled = true;
            } else if (["confirmed", "re-confirmed"].indexOf(action) > -1) {
              this.isConfirmed = true;
            } else if (action === "starts") {
              this.isStarted = true;
            } else if (action === "finished") {
              this.isFinished = true;
            } else if (action === "no-confirmed") {
              this.isUnconfirmed = true;
            } else if (action === "reassigned") {
              this.isReassigned = true;
            } else {
              this.isAnError = true;
            }
          } else {
            this.isAnError = true;
          }
        } else {
          this.isAnError = true;
        }
      } catch (error) {
        this.isAnError = true;
        this.load = false;
      }
    }
  },
  components: {
    navmenu: Navbarpages,
    swal,
    layoutFooter: layoutFooter
  }
};
</script>
